import { Modal } from "@/components/renderbus-modal";
import { Form, Input } from "@renderbus/ui";
import { FormProps, ModalProps } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export function ChangeCompanyModal({
  modalProps,
  formProps,
}: {
  modalProps?: ModalProps;
  formProps?: FormProps;
}) {
  const { t: centerT } = useTranslation("center");
  return (
    <Modal {...modalProps}>
      <FormWrapper>
        <Form {...formProps}>
          <Form.Item
            name="company"
            label={centerT("user_binfo_perfect_item_company_name")}
            rules={[
              {
                required: true,
                message: centerT(
                  "user_binfo_perfect_item_company_placeholder"
                ) as string,
              },
            ]}
          >
            <Input
              maxLength={100}
              placeholder={centerT(
                "user_binfo_perfect_item_company_placeholder"
              )}
            />
          </Form.Item>
          <Form.Item
            name="companySite"
            label={centerT("user_binfo_perfect_item_company_address")}
            rules={[
              {
                required: true,
                message: centerT(
                  "user_binfo_perfect_item_companySite_placeholder"
                ) as string,
              },
            ]}
          >
            <Input
              maxLength={100}
              placeholder={centerT(
                "user_binfo_perfect_item_companySite_placeholder"
              )}
            />
          </Form.Item>
          <Form.Item
            name="vatNumber"
            label={centerT("user_binfo_perfect_item_company_vat")}
            rules={[
              {
                required: true,
                message: centerT(
                  "user_binfo_perfect_item_company_vat_placeholder"
                ) as string,
              },
            ]}
          >
            <Input
              maxLength={100}
              placeholder={centerT(
                "user_binfo_perfect_item_company_vat_placeholder"
              )}
            />
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
}

const FormWrapper = styled.div`
  input {
    background: #2c2c31 !important;
  }
`;
